<!--
 * @Author: 吴作杰 15727841808@163.com
 * @Date: 2023-10-31 10:13:08
 * @LastEditors: 吴作杰 15727841808@163.com
 * @LastEditTime: 2023-11-03 11:06:53
 * @FilePath: /chaoyongtuan/src/views/cooperativeShop/shopList/components/editOrderDialog.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
	<el-dialog title="协同订单范围" :visible.sync="dialogVisible" width="30%" :before-close="handleClose">
		<div class="fz-12 mb-10 tips pr-12 pl-12">请选择可参与[自动同步样品协作申请]的商品所属招商，关闭后招商所认领的商品关联样品订单将不自动同步</div>
		<div class="infinite-list-wrapper" v-loading="initializeLoading">
			<div v-if="!initializeLoading">
				<div v-if="list.length">
					<div class="order-list-content">
						<div class="edit-head flex flex-align-center flex-just-between">
							<div class="edit-name">招商</div>
							<div class="edit-concern">协作关系</div>
						</div>
						<div class="line"></div>
						<div
							class="edit-list-content"
							v-infinite-scroll="loadList"
							:infinite-scroll-immediate="false"
							:infinite-scroll-disabled="loadListDisabled"
							:infinite-scroll-distance="20"
						>
							<div class="edit-list">
								<div class="edit-li flex flex-just-between" v-for="(item, index) in list" :key="index">
									<div class="edit-li-name font-h4-regular fz-14 yx-color-text-primary">{{ item.nickname | textFormat(12) }}</div>
									<el-switch
										:active-value="1"
										:inactive-value="0"
										:disabled="!collaborativeStatus"
										:value="+item.user_sample_status"
										@change="
											e => {
												switchChange(e, item, index);
											}
										"
									></el-switch>
								</div>
							</div>
						</div>
					</div>
					<div class="text-align-center fz-16 bottom-content">
						<i v-if="loading" class="el-icon-loading mt-10 yx-color-primary"></i>
						<div v-if="noMore && list.length" class="more fz-12 pt-10">——— 没有更多了 ———</div>
					</div>
				</div>
				<Empty v-else></Empty>
			</div>
		</div>
	</el-dialog>
</template>
<script>

import { userSmpleList, editUserSampleStatus } from '@/api/cooperativeShop';
export default {
	components: {
		
	},
	data() {
		return {
			dialogVisible: false,
			list: [],
			loading: false,
			total: 0,
			pageInfo: {
				page_index: 1,
				page_size: 10,
			},
			platformId: '',
			shopId: '',
			page_has: false,
			initializeLoading: false,
			collaborativeStatus: 1,
		};
	},
	computed: {
		noMore() {
			return !this.page_has;
		},
		loadListDisabled() {
			return this.noMore || this.loading;
		},
	},
	methods: {
		handleClose() {
			this.dialogVisible = false;
			this.pageInfo.page_index = 1;
			this.list = [];
		},
		show(platformId, shopId, collaborativeStatus) {
			this.initializeLoading = true;
			this.platformId = platformId;
			this.shopId = shopId;
			this.collaborativeStatus = +collaborativeStatus
			this.dialogVisible = true;
			this.getList();
		},
		async getList() {
			try {
				const { shopId, platformId } = this;
				this.loading = true;
				let params = {
					shopId,
					page_index: this.pageInfo.page_index,
					page_size: this.pageInfo.page_size,
					platformId,
				};
				const { data } = await userSmpleList(params);
				this.list = [...this.list, ...data.list];
				this.total = data.page.item_total;
				this.page_has = data.page.page_has;
			} finally {
				this.loading = false;
				this.initializeLoading = false;
			}
		},
		loadList() {
			if (this.loadListDisabled) {
				return;
			}
			++this.pageInfo.page_index;
			this.getList();
		},
		async switchChange(userSampleStatus, item, index) {
			let params = {
				platformId: this.platformId,
				userSampleStatus,
				userId: item.user_id,
				shopId: this.shopId,
			};
			const { code } = await editUserSampleStatus(params);
			if (code !== 0) return;
			this.$set(this.list[index], 'user_sample_status', +userSampleStatus);
			this.$message.success('操作成功');
		},
	},
};
</script>
<style lang="less" scoped>
.edit-head {
	padding: 0 12px 0 12px;
	.edit-name,
	.edit-concern {
		font-size: 14px;
		line-height: 24px;
		color: @color-text-secondary;
		font-family: 'PingFangSC-Semibold';
	}
}
.infinite-list-wrapper {
	min-height: 210px;
}
.line {
	margin-top: 13px;
	width: 100%;
	height: 1px;
	background: @color-gy3;
}
.edit-list-content {
	width: 100%;
	height: 310px;
	overflow: auto;
	.edit-list {
		padding: 0 12px 0 12px;
		.edit-li {
			padding: 16px 0 16px 0;
			border-bottom: 1px solid @color-gy3;
		}
	}
}
.tips {
	color: @color-gy7;
}
.more {
	color: @color-gy7;
}
.bottom-content {
	height: 20px;
}
</style>
